import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

// Components
import UserBadge from 'components/models/user/user-badge';
import { RelativeTime } from 'components/widgets/dates';

// This needs to be a full class to make FlipMove work
export default class TimelineItem extends React.Component { // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    children: PropTypes.node,
    user: PropTypes.object,
    userId: PropTypes.number,
    date: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  };

  render() {
    const { children, user, userId, date } = this.props;
    const hasUser = userId || (user && !isEmpty(user));

    return (
      <div className="timeline-item">
        <div className="timeline-date">
          { date && <RelativeTime date={date} /> }
        </div>
        { hasUser && <UserBadge user={user} userId={userId} /> }
        { !hasUser && <div className="user-badge"></div> }
        <div className="timeline-item-content-wrapper">
          <div className="timeline-item-content">
            {children}
          </div>
        </div>
      </div>
    );
  }
}
